import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";

import { BtnModule } from "libraries/ui_button/btn.module";
import { BookingTravellerCardComponent } from "./booking-traveller-card.component";
import { CardModule } from "libraries/ui_card/card.module";
import { MenuDetailsModule } from "libraries/hotel/components/menu-details/menu-details.module";
import { BookingTravellerModule } from "./components/booking-traveller/booking-traveller.module";
import { PaginationModule } from "libraries/component/pagination/pagination.module";
import { LoaderModule } from "libraries/component/loader/loader.module";
import { NotificationModule } from "libraries/component/notification/notification.module";

@NgModule({
    imports: [
        BtnModule,
        CardModule,
        MenuDetailsModule,
        CommonModule,
        BookingTravellerModule,
        PaginationModule,
        LoaderModule,
        NotificationModule,
    ],
    exports: [
        BookingTravellerCardComponent
    ],
    declarations: [
        BookingTravellerCardComponent
    ],
    providers: [],
})
export class BookingTravellerCardModule {
}
